import { useEffect, useState } from "react";

// Consulta de mídia reativa.
//
// `util/checkDevice.js` não serve aqui: é detecção por user-agent, está sem uso no projeto, e
// a especificação do painel fala de LARGURA DE JANELA ("abaixo de 768px de largura"), não de
// tipo de aparelho. Um desktop com a janela estreita precisa do painel inferior.
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const mql = window.matchMedia(query);
    const handler = (event) => setMatches(event.matches);

    setMatches(mql.matches);

    // addEventListener em MediaQueryList é recente; Safari antigo só tem addListener.
    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }

    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return matches;
}
